var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["custom-field-label-pane__editor", _vm.field.field_type] },
    [
      _c("ElInput", {
        ref: "inputRef",
        attrs: {
          placeholder: _vm.$t(
            "PtCustomFieldLabelPane.editor.placeholder." + _vm.field.field_type
          ),
          type: "textarea",
          size: "mini",
          autosize: { minRows: 1, maxRows: 7 },
          maxlength: _vm.MAX_STRING_LENGTH,
        },
        on: { blur: _vm.onFinishEdit },
        model: {
          value: _vm.value$,
          callback: function ($$v) {
            _vm.value$ = $$v
          },
          expression: "value$",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }